import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { MobileBadge } from "@faire/retailer-visitor-shared/icons/AppDownloadBadge/__internal__/MobileBadge";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useLocalization } from "@faire/web--source/common/localization/useLocalization";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { trackRetailerMobileFooterDesktopgooglePlayBadgeHover } from "@faire/web-api--source/events/retailerMobile/actionUnknown/footerDesktopGooglePlayBadgeHover";
import React from "react";
import styled from "styled-components";
var getBadge = function(locale) {
    if (SUPPORTED_LOCALES.includes(locale)) {
        return "https://cdn.faire.com/static/download-badges/google-play-".concat(locale, ".png");
    } else {
        return "https://cdn.faire.com/static/download-badges/google-play-en.png";
    }
};
var useQRCodeContainerSize = function() {
    if (useViewport().isDesktopAndAbove && !isLoggedInRetailer()) {
        return 160;
    } else {
        return 136;
    }
};
export var GooglePlayBadge = function() {
    var qrCodeContainerSize = useQRCodeContainerSize();
    return /*#__PURE__*/ _jsx(MobileBadge, {
        backgroundColor: "linear-gradient(transparent 20%, ".concat(Core.surface.default, " 80%)"),
        badge: /*#__PURE__*/ _jsx(GooglePlayImage, {}),
        qrCodeUrl: PLAY_STORE_QR_IMAGE_URL,
        qrCodeContainerWidth: qrCodeContainerSize,
        qrCodePadding: 12,
        trackingFunctionOnHover: useViewport().isTabletAndAbove && !isLoggedInRetailer() ? trackRetailerMobileFooterDesktopgooglePlayBadgeHover : undefined
    });
};
export var GooglePlayImage = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useLocalization = useLocalization(), locale = _useLocalization.intl.locale;
    var shouldAddMargin = locale === "en" || !SUPPORTED_LOCALES.includes(locale);
    var extraMargin;
    if (useViewport().isDesktopAndAbove && !isLoggedInRetailer()) {
        extraMargin = 12;
    } else {
        extraMargin = 10;
    }
    var qrCodeContainerSize = useQRCodeContainerSize();
    var badgeWidth = shouldAddMargin ? qrCodeContainerSize + 2 * extraMargin : qrCodeContainerSize;
    return /*#__PURE__*/ _jsx(PlayStoreBadge, {
        width: badgeWidth,
        src: getBadge(locale),
        alt: strictLocalize({
            id: "3YX6qA",
            defaultMessage: [
                {
                    type: 0,
                    value: "Google Play Store Badge"
                }
            ]
        }),
        $extraMargin: shouldAddMargin ? extraMargin : undefined
    });
};
var PlayStoreBadge = styled.img.withConfig({
    componentId: "sc-c1fa20d9-0"
})([
    "max-width:unset;margin:",
    ";clippath:inset(",
    ");"
], function(param) {
    var $extraMargin = param.$extraMargin;
    return $extraMargin ? getSpacing(-$extraMargin) : "auto";
}, getSpacing(10));
var SUPPORTED_LOCALES = [
    "af-ZA",
    "am-ET",
    "ar-AE",
    "az-AZ",
    "be-BY",
    "bg-BG",
    "bn-BD",
    "bs-BA",
    "ca-AD",
    "cs-CZ",
    "da-DK",
    "de-DE",
    "el-GR",
    "en",
    "es-ES",
    "et-EE",
    "eu-ES",
    "fa-IR",
    "fil-PH",
    "fr-CA",
    "fr-FR",
    "gl-ES",
    "gu-IN",
    "he-IL",
    "hi-IN",
    "hr-HR",
    "hu-HU",
    "hy-AM",
    "id-ID",
    "is-IS",
    "it-IT",
    "ja-JP",
    "ka-GE",
    "kk-KZ",
    "km-KH",
    "kn-IN",
    "ko-KR",
    "ky-KZ",
    "lo-LA",
    "lt-LT",
    "lv-LV",
    "mk-MK",
    "ml-IN",
    "mn-MN",
    "mr-IN",
    "ms-MY",
    "my-MM",
    "nb-NO",
    "ne-NP",
    "nl-NL",
    "pa-IN",
    "pl-PL",
    "pt-BR",
    "pt-PT",
    "ro-RO",
    "ru-RU",
    "si-LK",
    "sk-SK",
    "sl-SI",
    "sr-RS",
    "sv-SE",
    "ta-IN",
    "te-IN",
    "th-TH",
    "tr-TR",
    "uk-UA",
    "ur-PK",
    "uz-UZ",
    "vi-VN",
    "zh-CN",
    "zh-HK",
    "zh-TW",
    "zu-ZA"
];
var PLAY_STORE_QR_IMAGE_URL = "https://cdn.faire.com/fastly/9f4d40b9074c96c857d8b582a6eb90d93bae0e7672e670ac4382bdef66c0ca6a.png";
